import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from 'reactstrap'; // Import Alert dari Reactstrap
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(null); // State untuk error message
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage(null);
  
    try {
      const response = await fetch('https://app.rlagency.id/api_admin/cek-login-user.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
  
      const data = await response.json();
  
      if (response.ok && data.success) {
        localStorage.setItem('token', data.token); // Simpan token dari backend
        navigate('/admin/dashboard'); // Arahkan ke dashboard
      } else {
        setErrorMessage(data.message || 'Username atau password salah!');
      }
    } catch (error) {
      setErrorMessage('Terjadi kesalahan saat login. Silakan coba lagi.');
    }
  };
  

  return (
    <div className="login-box-body">
      <div className="login-container">
        {errorMessage && <Alert color="danger">{errorMessage}</Alert>} {/* Alert error */}
        
        <form className="login-form" onSubmit={handleLogin}>
          <h2>Welcome Back 👋</h2>
          <input 
            type="text" 
            placeholder="Username" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
            required 
          />
          <input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
          <button type="submit">Login</button>
          <p className="signup-link">
            Belum punya akun? <a href="/admin/register">Daftar</a> {/* Perbaiki link daftar */}
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
